export function getPageTitle(title: string): string {
  return `Sudozi | ${title}`;
}
